// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar2";
import Solutions from "./pages/Solutions";
import Products from "./pages/Products";
import Industries from "./pages/Industries";
import Footer from "./components/Footer";
import CaseStudies from "./pages/CaseStudies";

const WhyCRML = () => <h2>Why CRML Page</h2>;
const ContactSales = () => <h2>Contact Sales Page</h2>;

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/products" element={<Products />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/why-crml" element={<WhyCRML />} />
        <Route path="/contact-sales" element={<ContactSales />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
